import React, { useState } from "react";
import { getDynamicIconSize } from "../../liveBusLocations/tools";
import MapLocationDotIcon from "../../../components/icons/MapLocationDotIcon";
import { Divider, ListItem, ListItemText, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";

interface IDroppedLocationMarker {
  lat: number;
  lng: number;
  key: string;
  zoom: number;
  order: number;
  data: any;
}

const DroppedLocationMarker = ({
  zoom,
  order,
  data,
}: IDroppedLocationMarker) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const iconSize = getDynamicIconSize(zoom);

  return (
    <div
      style={{
        width: `${iconSize}px`, // Dynamic size based on zoom level
        height: `${iconSize}px`, // Dynamic size based on zoom level
        position: "absolute",
        transform: "translate(-50%, -100%)",
        cursor: "pointer",
        zIndex: isPopupVisible ? 11 : 10,
      }}
      onClick={() => {
        setIsPopupVisible(!isPopupVisible); // Toggle popup locally
      }}
    >
      <MapLocationDotIcon
        width={iconSize}
        height={iconSize}
        colorOne="#78716C"
        colorTwo="#3F3F46"
      />

      {isPopupVisible && (
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white", // Contrast with the marker image
            fontWeight: "bold",
            fontSize: `${Math.max(10, iconSize * 0.5)}px`, // Scale with iconSize, with a minimum size
            pointerEvents: "none", // Ensures the number doesn't block clicks
          }}
        >
          {order}
        </span>
      )}

      {/* Conditional Popup */}
      {isPopupVisible && (
        <div
          style={{
            position: "absolute",
            bottom: iconSize + 10, // Show above the marker
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "black",
            padding: "6px 12px",
            borderRadius: "4px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
            whiteSpace: "nowrap",
            zIndex: 2,
            fontSize: "12px",
            fontWeight: "normal",
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            UNASSIGNED (No. {order})
          </Typography>
          <Typography variant="body2" gutterBottom>
            {data.address}
          </Typography>

          {data.students && data.students.length > 0 && (
            <>
              <Divider style={{ margin: "10px 0px" }} />
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Students:
              </Typography>
              <List dense style={{ padding: 0 }}>
                {data.students.map((student: any, index: number) => (
                  <ListItem key={index} dense disableGutters>
                    <ListItemText
                      primary={`${student.firstName} ${student.lastName}`}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DroppedLocationMarker;
